import { atom } from "recoil";

export const showStop = atom({
  key: "showStop",
  default: {
    value: false,
  },
});
